import { PackageAmount } from "models/packages";

const packageAmountOptions = [
    {
        label: "1/4",
        value: PackageAmount.QuarterRow,
        size: 0.25
    },
    {
        label: "1/2",
        value: PackageAmount.HalfRow,
        size: 0.5
    },
    {
        label: "1",
        value: PackageAmount.One,
        size: 1
    },
    {
        label: "2",
        value: PackageAmount.Two,
        size: 2
    },
    {
        label: "3",
        value: PackageAmount.Three,
        size: 3
    },
    {
        label: "4",
        value: PackageAmount.Four,
        size: 4
    },
    {
        label: "5",
        value: PackageAmount.Five,
        size: 5
    },
    {
        label: "6",
        value: PackageAmount.Six,
        size: 6
    },
    {
        label: "7",
        value: PackageAmount.Seven,
        size: 7
    },
    {
        label: "8",
        value: PackageAmount.Eight,
        size: 8
    },
    {
        label: "9",
        value: PackageAmount.Nine,
        size: 9
    },
    {
        label: "10",
        value: PackageAmount.Ten,
        size: 10
    },
    {
        label: "11",
        value: PackageAmount.Eleven,
        size: 11
    },
    {
        label: "12",
        value: PackageAmount.Twelve,
        size: 12
    },
    {
        label: "13",
        value: PackageAmount.Thirteen,
        size: 13
    },
    {
        label: "14",
        value: PackageAmount.Fourteen,
        size: 14
    },
    {
        label: "15",
        value: PackageAmount.Fifteen,
        size: 15
    },
    {
        label: "16",
        value: PackageAmount.Sixteen,
        size: 16
    },
    {
        label: "17",
        value: PackageAmount.Seventeen,
        size: 17
    },
    {
        label: "18",
        value: PackageAmount.Eighteen,
        size: 18
    },
    {
        label: "19",
        value: PackageAmount.Nineteen,
        size: 19
    },
    {
        label: "20",
        value: PackageAmount.Twenty,
        size: 20
    },
    {
        label: "Not Applicable",
        value: PackageAmount.NotApplicable,
        size: 0
    },
];

export const totalBatchCount = (rows: number, per: 10 | 6) => {
    return Math.ceil(rows * per);
}

export default packageAmountOptions;
